export const CheckVersionInterval = 10 * 60 * 1000
